export const pul = {
  valyuta: "Валюта",
  som: "Сўм",
};
